/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Trend_AnalysisInputs */

const en_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus trend analysis`)
};

const ar_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل اتجاه التركيز`)
};

const de_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwerpunkt Trendanalyse`)
};

const es_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de tendencias de concentración`)
};

const fr_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse des tendances de concentration`)
};

const it_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi del trend di concentrazione`)
};

const ja_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中傾向の分析`)
};

const ko_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 추세 분석`)
};

const pt_br_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise das tendências de foco`)
};

const ru_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ тенденций фокусировки`)
};

const th_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวิเคราะห์เทรนด์การโฟกัส`)
};

const tr_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma trend analizi`)
};

const zh_cn_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注趋势分析`)
};

const zh_tw_focus_trend_analysis = /** @type {(inputs: Focus_Trend_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注趨勢分析`)
};

/**
* | output |
* | --- |
* | "Focus trend analysis" |
*
* @param {Focus_Trend_AnalysisInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_trend_analysis = /** @type {((inputs?: Focus_Trend_AnalysisInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Trend_AnalysisInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_trend_analysis(inputs)
	if (locale === "ar") return ar_focus_trend_analysis(inputs)
	if (locale === "de") return de_focus_trend_analysis(inputs)
	if (locale === "es") return es_focus_trend_analysis(inputs)
	if (locale === "fr") return fr_focus_trend_analysis(inputs)
	if (locale === "it") return it_focus_trend_analysis(inputs)
	if (locale === "ja") return ja_focus_trend_analysis(inputs)
	if (locale === "ko") return ko_focus_trend_analysis(inputs)
	if (locale === "pt_br") return pt_br_focus_trend_analysis(inputs)
	if (locale === "ru") return ru_focus_trend_analysis(inputs)
	if (locale === "th") return th_focus_trend_analysis(inputs)
	if (locale === "tr") return tr_focus_trend_analysis(inputs)
	if (locale === "zh_cn") return zh_cn_focus_trend_analysis(inputs)
	return zh_tw_focus_trend_analysis(inputs)
});